<div class="p-justify-center p-component">
    <div class="chartValues">
        <div class="p-grid p-justify-center">
            <div class="p-col-10 p-sm-8 p-md-8 p-lg-4 p-xl-2">
                <div class="p-inputgroup p-fluid">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">From</span>
                        <p-calendar [(ngModel)]="date1" name="date1" [showIcon]="true" [style]="{'height':'100%'}">
                        </p-calendar>
                    </div>
                </div>
            </div>
            <div class="p-col-10 p-sm-8 p-md-8 p-lg-4 p-xl-2">
                <div class="p-inputgroup p-fluid">
                    <span class="p-inputgroup-addon">To</span>
                    <p-calendar [(ngModel)]="date2" name="date2" [showIcon]="true" [style]="{'height':'100%'}">
                    </p-calendar>
                </div>
            </div>
            <div class="p-field p-col-10 p-sm-8 p-md-8 p-lg-4 p-xl-2">
                <button pButton type="submit" label="Submit" (click)="onSubmit($event)"></button>
            </div>
            <div *ngIf="dataFetching === true">
                <p-progressSpinner class="spinner" strokeWidth="4" fill="#EEEEEE" animationDuration="20s">
                </p-progressSpinner>
            </div>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-10 p-sm-8 p-md-8 p-lg-8 p-xl-8 alignment">
            <p-chart type="bar" [data]="data"></p-chart>
        </div>
    </div>
</div>